export default function Footer() {
    return (
        <footer
            className="border-t border-[var(--border)] mt-24"
            data-testid="site-footer"
        >
            <div className="max-w-7xl mx-auto px-5 md:px-8 py-10 flex flex-col md:flex-row gap-6 md:gap-0 items-start md:items-center justify-between">
                <div>
                    <div className="flex items-center gap-2">
                        <span className="font-display font-black text-white text-lg">
                            FLOW
                        </span>
                        <span className="font-brush text-[var(--lime)] text-2xl -mt-1 -ml-1">
                            .lab
                        </span>
                    </div>
                    <p className="font-mono text-xs text-[var(--muted)] mt-2 max-w-md">
                        A 6-week aquaponics curriculum built for the block.
                        Science, food sovereignty, and futures grown in water.
                    </p>
                </div>
                <div className="font-mono text-xs text-[var(--muted)] flex flex-col gap-1">
                    <span>{`// open educational resource`}</span>
                    <span>{`// CC BY-SA — remix it, teach it`}</span>
                </div>
            </div>
        </footer>
    );
}
